import { BaseAPI } from '@/lib/api';

export interface NewsItem {
  id: number;
  title: string;
  content: string;
  summary: string;
  date: string;
  author: string;
  category: string;
  is_featured: boolean;
}

class NewsAPI extends BaseAPI {
  // Получение списка новостей
  async getNews(limit?: number): Promise<NewsItem[]> {
    const params = limit ? `?limit=${limit}` : '';
    return this.makeRequest<NewsItem[]>(`/api/news${params}`);
  }

  // Получение конкретной новости
  async getNewsById(id: string): Promise<NewsItem> {
    return this.makeRequest<NewsItem>(`/api/news/${id}`);
  }
}

export const newsAPI = new NewsAPI();
